// https://github.com/sindresorhus/query-string
import queryString from 'query-string'
const { parse, stringify } = queryString
export { parse, stringify }
export default queryString
